const mobileMenu = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    const mobileSideMenu = document.querySelector('.mobile-menu');
    const closeMenuBtn = document.querySelector('.close-menu');
    const body = document.body;

    if (!mobileSideMenu) return;

    if (mobileMenuBtn) {
      mobileMenuBtn.addEventListener('click', function () {
        mobileSideMenu.classList.add('show-menu');
        body.style.overflow = 'hidden';
      });
    }

    if (closeMenuBtn) {
      closeMenuBtn.addEventListener('click', function () {
        mobileSideMenu.classList.remove('show-menu');
        body.style.overflow = 'visible';
      });
    }

    const submenuItems = document.querySelectorAll(
      '.mobile-menu .menu-item-has-children'
    );

    const setSubmenuFocusable = (submenu, isOpen) => {
      const focusable = submenu.querySelectorAll(
        'a, button, input, select, textarea'
      );

      focusable.forEach(el => {
        if (isOpen) {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', '-1');
        }
      });

      submenu.setAttribute('aria-hidden', String(!isOpen));
    };

    submenuItems.forEach(item => {
      const toggleBtn = item.querySelector('a');
      const submenu = item.querySelector('ul');

      if (!toggleBtn || !submenu) return;

      submenu.style.height = '0';
      submenu.style.overflow = 'hidden';
      setSubmenuFocusable(submenu, false);

      toggleBtn.addEventListener('click', e => {
        e.preventDefault();

        submenuItems.forEach(subItem => {
          const subUl = subItem.querySelector('ul');
          if (!subUl) return;

          const isCurrent = subItem === item;
          const isOpen = subItem.classList.contains('active');

          if (isCurrent && !isOpen) {
            subItem.classList.add('active');
            subUl.style.height = subUl.scrollHeight + 'px';
            setSubmenuFocusable(subUl, true);
          } else {
            subItem.classList.remove('active');
            subUl.style.height = '0';
            setSubmenuFocusable(subUl, false);
          }
        });
      });
    });
  });
};

export default mobileMenu;
